import { PartialTheme } from '@fluentui/react-theme-provider';

export function getMeetingInviteTheme(densityModeString: string): PartialTheme {
    if (!densityModeString) {
        return {};
    }
    if (densityModeString === 'compact') {
        return meetingInviteTheme('20px', '12px');
    }
    if (densityModeString === 'medium') {
        return meetingInviteTheme('24px', '12px');
    }
    return meetingInviteTheme('28px', '14px');
}

const meetingInviteTheme = (height: string, fontSize: string) => {
    return {
        components: {
            DefaultButton: {
                styles: {
                    root: {
                        height: height,
                        fontSize: fontSize,
                    },
                    flexContainer: {
                        height: 'auto',
                    },
                },
            },
        },
    };
};
